import { render, staticRenderFns } from "./ViewRequestModal.vue?vue&type=template&id=640410b3&scoped=true&"
import script from "./ViewRequestModal.vue?vue&type=script&lang=js&"
export * from "./ViewRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewRequestModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ViewRequestModal.vue?vue&type=style&index=1&id=640410b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640410b3",
  null
  
)

export default component.exports